import _extends from "@babel/runtime/helpers/esm/extends";
// **********************************
// Auto-generated file, do NOT modify
// **********************************
import React, { forwardRef, memo, useId } from 'react';
import { createStyledIcon } from '../base';
const Icon = _ref => {
  let {
    svgRef,
    title,
    theme,
    ...props
  } = _ref;
  const uniqueTitleId = useId();
  const titleId = title ? props.titleId || uniqueTitleId : undefined;
  const ariaHidden = titleId ? undefined : true;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": ariaHidden,
    "aria-labelledby": titleId,
    fill: "currentColor",
    height: 24,
    ref: svgRef,
    stroke: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 24 24",
    width: 24
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29L5.7 12.7a.996.996 0 111.41-1.41L10 14.17l6.88-6.88a.996.996 0 111.41 1.41l-7.59 7.59a.996.996 0 01-1.41 0z"
  }));
};
const IconWithForwardedRef = /*#__PURE__*/forwardRef((iconProps, ref) => /*#__PURE__*/React.createElement(Icon, _extends({}, iconProps, {
  svgRef: ref
})));
export const CheckCircleIcon = /*#__PURE__*/memo(createStyledIcon(IconWithForwardedRef));
CheckCircleIcon.displayName = 'CheckCircleIcon';